export const translations = {
    configuracoes: {
        pt: 'Configurações',
        en: 'Settings',
        de: 'Einstellungen',
        es: 'Configuración',
      },
      novaTaxa: {
        pt: 'Nova Taxa',
        en: 'New Toll',
        de: 'Neuer Gebühr',
        es: 'Nueva Tasa',
      },
};